import { connect } from 'react-redux';
import EvalTokenSetter from './EvalTokenSetter';
import { setIsAdmin } from './Login.action';

const mapDispatchToProps = (dispatch) => ({
  setIsAdmin: (token) => dispatch(setIsAdmin(token)),
});

export default connect(null, mapDispatchToProps)(EvalTokenSetter);
